import React from 'react';

export default function IconIN() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path
                fill="#FAB446"
                d="M32 7.506H0V1.069C0 .764.247.517.552.517H31.45c.304 0 .551.247.551.552v6.437Z"
            />
            <path
                fill="#73AF00"
                d="M31.449 21.483H.552A.552.552 0 0 1 0 20.93v-6.437h32v6.437a.552.552 0 0 1-.551.552Z"
            />
            <path fill="#F5F5F5" d="M32 7.506H0v6.988h32V7.506Z" />
            <path
                fill="#41479B"
                d="M16 13.966A2.969 2.969 0 0 1 13.035 11 2.969 2.969 0 0 1 16 8.035 2.969 2.969 0 0 1 18.966 11 2.969 2.969 0 0 1 16 13.966Zm0-5.38A2.416 2.416 0 0 0 13.586 11 2.416 2.416 0 0 0 16 13.414 2.416 2.416 0 0 0 18.414 11 2.416 2.416 0 0 0 16 8.586Z"
            />
            <path fill="#41479B" d="M16 11.336a.336.336 0 1 0 0-.672.336.336 0 0 0 0 .672Z" />
            <path fill="#41479B" d="m16 11.05-.854.087-1.835-.087v-.1l1.835-.087.855.087v.1Z" />
            <path fill="#41479B" d="m16 11.05.855.087 1.835-.087v-.1l-1.835-.087-.854.087v.1Z" />
            <path
                fill="#41479B"
                d="m15.95 11-.086-.854.086-1.836h.1l.087 1.836-.086.854h-.101ZM15.95 11l-.086.854.086 1.836h.1l.087-1.835-.086-.855h-.101Z"
            />
            <path
                fill="#41479B"
                d="m15.965 11.036-.665-.543-1.237-1.36.071-.07 1.359 1.236.543.665-.071.072Z"
            />
            <path
                fill="#41479B"
                d="m15.965 11.036.543.665 1.359 1.237.071-.072-1.237-1.358-.665-.543-.071.07Z"
            />
            <path
                fill="#41479B"
                d="m15.965 10.964.543-.665 1.359-1.236.071.07-1.237 1.36-.665.543-.071-.072Z"
            />
            <path
                fill="#41479B"
                d="m15.965 10.964-.665.543-1.237 1.36.071.07 1.359-1.236.543-.665-.071-.072Z"
            />
            <path
                fill="#41479B"
                d="m16.02 11.047-.757.406-1.728.623-.039-.093 1.663-.782.822-.248.039.094Z"
            />
            <path
                fill="#41479B"
                d="m16.02 11.047.822-.248 1.663-.782-.04-.093-1.728.623-.756.406.039.094Z"
            />
            <path
                fill="#41479B"
                d="m15.954 11.02-.407-.757-.623-1.728.094-.039.782 1.662.247.823-.093.039Z"
            />
            <path
                fill="#41479B"
                d="m15.954 11.02.247.822.782 1.662.093-.038-.622-1.729-.407-.756-.093.039Z"
            />
            <path
                fill="#41479B"
                d="m15.981 11.047-.822-.248-1.663-.782.039-.093 1.728.623.757.406-.039.094Z"
            />
            <path
                fill="#41479B"
                d="m15.981 11.047.756.406 1.729.623.038-.093-1.662-.782-.822-.248-.039.094Z"
            />
            <path
                fill="#41479B"
                d="m15.954 10.98.247-.822.782-1.662.093.039-.622 1.728-.407.757-.093-.04Z"
            />
            <path
                fill="#41479B"
                d="m15.954 10.98-.407.757-.623 1.729.094.038.782-1.662.247-.822-.093-.04Z"
            />
            <path fill="#F5F5F5" d="M16 11.454a.454.454 0 1 0 0-.907.454.454 0 0 0 0 .907Z" />
            <path fill="#41479B" d="M16 11.272a.272.272 0 1 0 0-.544.272.272 0 0 0 0 .544Z" />
        </svg>
    );
}
